import request from "@/utils/request";

/**
 *  获取地区列表
 * @param {*} data
 * @returns
 */
export function fetchLocation(params) {
  return request({
    url: "/api/location",
    method: "get",
    params,
  });
}
